import { render, staticRenderFns } from "./my-invest-card.vue?vue&type=template&id=699a8a30"
import script from "./my-invest-card.vue?vue&type=script&lang=js"
export * from "./my-invest-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports